/* 🤖 this file was generated by svg-to-ts */
export const iconAave: {
  name: 'aave';
  data: string;
} = {
  name: 'aave',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m-2.97 16.78c-1.37.22-2.66-.71-2.89-2.08-.22-1.37.71-2.66 2.08-2.89 1.37-.22 2.66.71 2.89 2.08.22 1.37-.71 2.66-2.08 2.89m6.58 0c-1.37.22-2.66-.71-2.89-2.08-.22-1.37.71-2.66 2.08-2.89 1.37-.22 2.66.71 2.89 2.08.22 1.37-.71 2.66-2.08 2.89m5.51-.26c0-5.22-4.09-9.45-9.21-9.45S6.7 11.3 6.7 16.52H3.54c0-6.96 5.54-12.61 12.37-12.61s12.37 5.65 12.37 12.61z"/></svg>`,
};
